<script lang="ts">
  import { defineComponent } from 'vue';
  import Mixins from '@/helpers/mixins';
  import { MainMenuItems, StoreMutations } from '@/helpers/enums';
  import MainMenuItem from '@/components/ui/menus/MainMenuItem.vue';
  import {
    stopWatchCountReceivedSupportCenter,
    watchCountReceivedSupportCenter,
  } from '@/providers/laundryheap/api-helpers';

  export default defineComponent({
    components: {
      MainMenuItem,
    },
    mixins: [Mixins],
    props: {
      modelValue: {
        type: String as () => MainMenuItems,
        default: MainMenuItems.home,
      },
    },
    emits: {
      updateModelValue: (item: MainMenuItems) => true,
    },
    computed: {
      supportNotificationCount(): number | null {
        return this.$store.state.supportNotification;
      },
    },
    async mounted(): Promise<void> {
      await this.getSupportNotification();
    },
    unmounted(): void {
      stopWatchCountReceivedSupportCenter();
    },
    methods: {
      async getSupportNotification(): Promise<void> {
        const count = await watchCountReceivedSupportCenter();

        this.$store.commit(StoreMutations.setSupportNotification, count);
      },
    },
  });
</script>

<template>
  <div
    class="main-menu--wrapper box-shadow d-flex justify-content-between flex-row px-24"
  >
    <MainMenuItem
      :active="modelValue === $enums.MainMenuItems.home"
      :menu-item="$enums.MainMenuItems.home"
      @select="(item) => $emit('updateModelValue', item)"
    />
    <MainMenuItem
      :active="modelValue === $enums.MainMenuItems.orders"
      :menu-item="$enums.MainMenuItems.orders"
      @select="(item) => $emit('updateModelValue', item)"
    />
    <MainMenuItem
      :active="modelValue === $enums.MainMenuItems.scan"
      :menu-item="$enums.MainMenuItems.scan"
      @select="(item) => $emit('updateModelValue', item)"
    />
    <MainMenuItem
      :active="modelValue === $enums.MainMenuItems.history"
      :menu-item="$enums.MainMenuItems.history"
      @select="(item) => $emit('updateModelValue', item)"
    />
    <MainMenuItem
      :active="modelValue === $enums.MainMenuItems.support"
      :menu-item="$enums.MainMenuItems.support"
      :notification-number="supportNotificationCount"
      @select="(item) => $emit('updateModelValue', item)"
    />
  </div>
</template>

<style lang="scss" scoped>
  .main-menu--wrapper {
    background-color: $white;
    border-top-left-radius: 3 * $base-unit;
    border-top-right-radius: 3 * $base-unit;

    /* Cuts off the bottom shadow */
    clip-path: inset(#{-1.5 * $base-unit} 0 0 0);

    > * {
      width: 15%;
    }
  }
</style>
